// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","389":"6880abdc","453":"8701dc61","455":"9eeb451c","857":"a22ddff1","977":"ca257b29"}[chunkId] + ".chunk.js";
};